import React from "react";

import { Skeleton } from "../../skeleton";

export const WhatsNextCardSkeleton = () => {
  return (
    <div className="flex flex-col">
      <div className="rounded-4xl overflow-hidden">
        <Skeleton height="100%" className="aspect-[470/600]" />
      </div>
      <div className="flex justify-center gap-3 p-5">
        {new Array(2).fill(null).map((_, i) => (
          <Skeleton width="15%" height={20} key={i} />
        ))}
      </div>
      <div className="flex flex-col items-center flex-1 text-2xl font-medium pb-5 gap-3">
        <Skeleton height={20} />
        <Skeleton width="65%" height={20} />
      </div>
    </div>
  );
};
